// GenericModel.ts

//*************************************** */
// ***** EXTENDS THIS MODELS WITH BASE **///
//*************************************** */

export default class GenericModel {
    id                      : number;
    

    constructor(dict = null)
    {
      if (dict !== null)
      {
        this.id                     = dict["id"] || null;
      }

    }

    isReal()
    {
      return this.id !== null && this.id !== undefined;
    }

  }
